import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('master-item-list/index', {params});
    },
    getMaterialGroupPR(params) {
        return Service().get('master-item-list/get-master-item-list', {params});
    },
    stats() {
        return Service().get('master-item-list/stats');
    },
    import(params) {
        return Service().post('master-item-list/import', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    show(id) {
        return Service().get('master-item-list/show/'+id);
    },
    create(params) {
        return Service().post('master-item-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('master-item-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('master-item-list/delete/'+id);
    },
}